
































































































































































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'Imprint',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
